module.exports = __webpack_public_path__ + "static/media/air_horn.532d931.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/air_horn.mp3
// module id = OtfI
// module chunks = 82